import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AdvancedQualification, QualificationCategory } from '@ps/survey-utils';

import { AdvancedQualificationApi } from '../../api/advanced-qualifications/advanced-qualification.api';

@Injectable({ providedIn: 'root' })
export class SurveyQuestionService {
  private readonly _api = inject(AdvancedQualificationApi);

  public getQuestions(
    search: string,
    categoryIds: number[],
    locale: string,
  ): Observable<AdvancedQualification[]> {
    return this._api.getQuestions(search, categoryIds, locale);
  }

  public categories(): Observable<QualificationCategory[]> {
    return this._api.categories();
  }
}
